import { StateCreator } from "zustand";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";

export interface BuildingRegulationDetailsState {
    [x: string]: RecordDetailsTabNames;
}

export interface BuildingRegulationDetailsSlice {
    buildingRegulationDetails: BuildingRegulationDetailsState;
    setBuildingRegulationDetails: (state: BuildingRegulationDetailsState) => void;
    updateBuildingRegulationTab: (recordId: string | number, tab: RecordDetailsTabNames) => void;
}

const initialBuildingRegulationDetailsState: BuildingRegulationDetailsState = {};

export const createBuildingRegulationDetailsSlice: StateCreator<BuildingRegulationDetailsSlice, [], [], BuildingRegulationDetailsSlice> = (set) => ({
    buildingRegulationDetails: initialBuildingRegulationDetailsState,
    setBuildingRegulationDetails: (state) => set({ buildingRegulationDetails: state }),
    updateBuildingRegulationTab: (recordId, tab) =>
        set((state) => ({ buildingRegulationDetails: { ...state.buildingRegulationDetails, [recordId]: tab } })),
});

